import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import LeadDashboard from './pages/LeadDashboard';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>cellrox - Professional Device Repair Mississauga | iPhone, iPad, MacBook, Laptop</title>
        <meta name="description" content="Expert repair for iPhone, iPad, MacBook, laptops & all smartphones at cellrox inside Walmart Matheson. 90-day warranty, same-day service. Open 10 AM - 10 PM daily. Call 905-699-6599" />
        <meta name="keywords" content="iPhone repair Mississauga, iPad repair, MacBook repair, laptop repair, phone repair near me, cellrox, iphonerepairnearme.ca, Walmart Matheson repair" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://iphonerepairnearme.ca/" />
        <meta property="og:title" content="cellrox - Expert Device Repair in Mississauga" />
        <meta property="og:description" content="Professional repair for all devices with 90-day warranty. Located inside Walmart Matheson. 10 AM - 10 PM daily." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1673713234831-bff865b62328?w=1200" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://iphonerepairnearme.ca/" />
        <meta property="twitter:title" content="cellrox - Expert Device Repair in Mississauga" />
        <meta property="twitter:description" content="Professional repair for all devices with 90-day warranty." />
        <meta property="twitter:image" content="https://images.unsplash.com/photo-1673713234831-bff865b62328?w=1200" />

        {/* Local Business Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "cellrox",
            "alternateName": "iphonerepairnearme.ca",
            "image": "https://images.unsplash.com/photo-1673713234831-bff865b62328",
            "description": "Professional device repair for iPhone, iPad, MacBook, laptops and all smartphones with 90-day warranty.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "800 Matheson Blvd West, Inside Walmart",
              "addressLocality": "Mississauga",
              "addressRegion": "ON",
              "addressCountry": "CA"
            },
            "telephone": "+19056996599",
            "email": "info@iphonerepairnearme.ca",
            "url": "https://iphonerepairnearme.ca",
            "priceRange": "$79 - $449",
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                "opens": "10:00",
                "closes": "22:00"
              }
            ],
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "200"
            },
            "sameAs": [
              "https://iphonerepairnearme.ca"
            ]
          })}
        </script>
      </Helmet>

      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leads" element={<LeadDashboard />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </>
  );
}

export default App;
